import dayIsNowDayBefore from './dayIsNowDayBefore';
import dayIsSameDay from './dayIsSameDay';
import dayIsNowDayAfter from './dayIsNowDayAfter';
import buildSbmParams from './buildSbmParams';
import analyzeAvailability from './analyzeAvailability';
import moment from 'moment-timezone';
import cloneDeep from 'lodash/cloneDeep';

const createDayOff = (
    convertedDayOff,
    exceptionDate,
    convertedExceptionComparison,
    operationType,
    conversionType,
    exceptionsInCynoTime,
    availabilityDaysInCynoTime,
    datesOff,
    SBMId) => {
        
    let sbmParamsObjectSet = {
        deleteDates: [],
        exceptionsSet: {},
    };
    let dayOffParamsTemplate = {
        "start_time":"",
        "end_time":"",
        "is_day_off":0,
        "breaktime":[{"start_time":"", "end_time":""}],
        "index":"",
        "name":"",
        "date":"",
        "unit_group_id":SBMId.toString(),
        "event_id":""
    };
    convertedDayOff.forEach((times, i) => {
        // 'i' tells us that time zone conversion has moved timeBlocks to a past day/date(0) or a future day/date(2)
        if (times.length > 0) {
            if (dayIsNowDayBefore(i)) {
                const pastDate = moment(moment.utc(exceptionDate)).add(-1, 'd').format("YYYY-MM-DD");
                const dateIndex = moment(pastDate).day();
                if (exceptionsInCynoTime[pastDate]) {

                    let remainingExceptionTimes = analyzeAvailability(convertedExceptionComparison[i], cloneDeep(exceptionsInCynoTime[pastDate]));

                    if (remainingExceptionTimes) {
                        let sbmExceptionParams = buildSbmParams(remainingExceptionTimes, pastDate, operationType, SBMId);
                        sbmParamsObjectSet.exceptionsSet[pastDate] = sbmExceptionParams;
                        exceptionsInCynoTime[pastDate] = remainingExceptionTimes;
                    }
                    else if (!remainingExceptionTimes) {
                        sbmParamsObjectSet.deleteDates.push(pastDate);
                        let indexToRemove = exceptionsInCynoTime.indexOf([pastDate]);
                        exceptionsInCynoTime.splice(indexToRemove, 1);
                    }
                }
                else if (!exceptionsInCynoTime[pastDate]) {
                    
                    let remainingAvailabilityTimes = analyzeAvailability(convertedExceptionComparison[i], cloneDeep(availabilityDaysInCynoTime[pastDateIndex]));
                   
                    if (remainingAvailabilityTimes) {
                        let sbmExceptionParams = buildSbmParams(remainingAvailabilityTimes, pastDate, operationType, SBMId);
                        sbmParamsObjectSet.exceptionsSet[pastDate] = sbmExceptionParams;
                        exceptionsInCynoTime[pastDate] = remainingAvailabilityTimes;
                    };
                    
                };
            }
            if (dayIsSameDay(i)) {
                let dayOffParams = cloneDeep(dayOffParamsTemplate);
                if (exceptionsInCynoTime[exceptionDate] && convertedDayOff[0].length > 0) {

                    let breakEnd = exceptionsInCynoTime[exceptionDate][0][0];
                    
                    dayOffParams.breaktime[0].start_time = "00:00";
                    dayOffParams.breaktime[0].end_time = breakEnd;
                    dayOffParams.date = exceptionDate.toString();
                    
                    datesOff[exceptionDate] = ["off"];
                    sbmParamsObjectSet.exceptionsSet[exceptionDate] = dayOffParams;
                }
                else if (exceptionsInCynoTime[exceptionDate] && convertedDayOff[2].length > 0) {

                    let endOfDayIndex = exceptionsInCynoTime[exceptionDate].length - 1;
                    let breakStart = exceptionsInCynoTime[exceptionDate][endOfDayIndex][1];
                    
                    dayOffParams.breaktime[0].start_time = breakStart;
                    dayOffParams.breaktime[0].end_time = "24:00";
                    dayOffParams.date = exceptionDate.toString();
                    
                    datesOff[exceptionDate] = ["off"];
                    sbmParamsObjectSet.exceptionsSet[exceptionDate] = dayOffParams;

                }
                else if (!exceptionsInCynoTime[exceptionDate]) {
                    // let dateIndex = (moment(exceptionDate).day() === 0) ? 7 : moment(exceptionDate).day();
                    const dateIndex = moment(exceptionDate).day();
                    let remainingAvailabilityTimes = analyzeAvailability(convertedExceptionComparison[i], cloneDeep(availabilityDaysInCynoTime[dateIndex]));
                   
                    if (remainingAvailabilityTimes) {
                        if (convertedDayOff[0].length > 0) {
                            let breakEnd = remainingAvailabilityTimes[0][0];
                            dayOffParams.breaktime[0].start_time = "00:00";
                            dayOffParams.breaktime[0].end_time = breakEnd;
                            dayOffParams.date = exceptionDate.toString();
                            datesOff[exceptionDate] = ["off"];
                            sbmParamsObjectSet.exceptionsSet[exceptionDate] = dayOffParams;
                        }
                        else if (convertedDayOff[2].length > 0) {
                            let endOfDayIndex = remainingAvailabilityTimes.length - 1;
                            let breakStart = remainingAvailabilityTimes[endOfDayIndex][1];
                            dayOffParams.breaktime[0].start_time = breakStart;
                            dayOffParams.breaktime[0].end_time = "24:00";
                            dayOffParams.date = exceptionDate.toString();
                            datesOff[exceptionDate] = ["off"];
                            sbmParamsObjectSet.exceptionsSet[exceptionDate] = dayOffParams;
                        }
                    }
                    else if (!remainingAvailabilityTimes) {
                        dayOffParams.breaktime[0].start_time = "00:00";
                        dayOffParams.breaktime[0].end_time = "24:00";
                        dayOffParams.date = exceptionDate.toString();
                        datesOff[exceptionDate] = ["off"];
                        sbmParamsObjectSet.exceptionsSet[exceptionDate] = dayOffParams;
                    }
                }
            }
            if (dayIsNowDayAfter(i)) {
                const nextDate = moment(moment.utc(exceptionDate)).add(1, 'd').format("YYYY-MM-DD");
                const nextDateIndex = moment(nextDate).day();
                if (exceptionsInCynoTime[nextDate]) {

                    let remainingExceptionTimes = this.analyzeAvailability(convertedExceptionComparison[i], cloneDeep(exceptionsInCynoTime[nextDate]));

                    if (remainingExceptionTimes) {
                        let sbmExceptionParams = buildSbmParams(remainingExceptionTimes, nextDate, operationType, SBMId);
                        sbmParamsObjectSet.exceptionsSet[nextDate] = sbmExceptionParams;
                        exceptionsInCynoTime[nextDate] = remainingExceptionTimes;
                    }
                    else if (!remainingExceptionTimes) {
                        sbmParamsObjectSet.deleteDates.push(nextDate);
                        let indexToRemove = exceptionsInCynoTime.indexOf([nextDate]);
                        exceptionsInCynoTime.splice(indexToRemove, 1);
                    }
                }
                else if (!exceptionsInCynoTime[nextDate]) {
                    
                    let remainingAvailabilityTimes = analyzeAvailability(convertedExceptionComparison[i], cloneDeep(availabilityDaysInCynoTime[nextDateIndex]));
                   
                    if (remainingAvailabilityTimes) {
                        let sbmExceptionParams = buildSbmParams(remainingAvailabilityTimes, nextDate, operationType, SBMId);
                        sbmParamsObjectSet.exceptionsSet[nextDate] = sbmExceptionParams;
                        exceptionsInCynoTime[nextDate] = remainingAvailabilityTimes;
                    };
                    
                };
            };
        };
    });
    return [sbmParamsObjectSet, exceptionsInCynoTime, datesOff];
};

export default createDayOff;


// WEBPACK FOOTER //
// ./src/js/containers/ProviderContainer/utils/createDayOff.js